export const DISPATCH_CHECK_USER_EXISTS = 'DISPATCH_CHECK_USER_EXISTS';
export const DISPATCH_CHECK_USER_LOGGED_IN_BEFORE = 'DISPATCH_CHECK_USER_LOGGED_IN_BEFORE';
export const RETRIEVE_SSO_STATUS = 'RETRIEVE_SSO_STATUS';
export const UPDATE_SSO_STATUS_OFFLINE = 'UPDATE_SSO_STATUS_OFFLINE';
export const FETCH_USER = 'FETCH_USER';
export const DISPATCH_HAS_CHECK_CONCURRENCY_EXCEEDED = 'DISPATCH_HAS_CHECK_CONCURRENCY_EXCEEDED';
export const DISPATCH_CHECK_CORPORATE_SSO_LOGIN_FOR_USERNAME = 'DISPATCH_CHECK_CORPORATE_SSO_LOGIN_FOR_USERNAME';

export const FETCH_INVITE_DETAILS = 'FETCH_INVITE_DETAILS';
